import type { PropType } from "./prop";

/**
 * Side 的数据结构或可选取值约定。
 */
export type Side = "left" | "right";
/**
 * opposite，供本模块相关规则使用。
 */
export const opposite = (side: Side): Side => (side === "left" ? "right" : "left");

/** 提交的是身份与槽位，不跨快照传递可变领域对象。 */
export type Operation =
    | { /**
     * kind，保存当前实例的kind状态。
     */
    kind: "skill"; /**
     * petId，保存当前实例的petId状态。
     */
    petId: number; /**
     * skillIndex，保存当前实例的skillIndex状态。
     */
    skillIndex: number }
    | { /**
     * kind，保存当前实例的kind状态。
     */
    kind: "switch"; /**
     * petId，保存当前实例的petId状态。
     */
    petId: number }
    | { /**
     * kind，保存当前实例的kind状态。
     */
    kind: "prop"; /**
     * propType，保存当前实例的propType状态。
     */
    propType: PropType }
    | { /**
     * kind，保存当前实例的kind状态。
     */
    kind: "skip" }
    | { /**
     * kind，保存当前实例的kind状态。
     */
    kind: "surrender" };

/**
 * skipOperation，供本模块相关规则使用。
 */
export const skipOperation: Operation = { kind: "skip" };
/**
 * surrenderOperation，供本模块相关规则使用。
 */
export const surrenderOperation: Operation = { kind: "surrender" };
